let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8xOzP")).then(() => parcelRequire('1bupc'));